module.exports = "https://static.wanderu.com/ui-react/_next/static/media/location-icon.4ac1f91b.svg";